import { IconBuildingBank, IconCirclePlus, IconDots, IconIdBadge2, IconLink, IconLinkPlus, IconReceipt, IconReceiptRupee, IconRosetteDiscountCheck, IconRosetteDiscountCheckOff, IconTax, IconUserScan, IconX } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Badge } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import DateRange from '../../components/DateRange/DateRange'
import StatsCard from '../../components/StatsCard/StatsCard'
import Layout from '../../layout/Layout'
import { dateTimeConverter } from '../../utils/dateTimeConverter'
import AddGstModal from './Components/AddGstModal'
import AddPanModal from './Components/AddPanModal'
import AddPaymentMethod from './Components/AddPaymentMethod'
import InfluencerGraph from './Components/InfluencerGraph'
import InfluencerListOfAgentTable from './Components/InfluencerListOfAgentTable'
import UpdateAgent from './Components/UpdateAgent'

const AgentDetails = () => {
    const [selectedBank, setSelectedBank] = useState(1);
    const [profileData, setProfileData] = useState(null);
    const { agentId } = useParams();
    const [bankDetails, setBankDetails] = useState([]);

    async function getAgentDetails() {
        let resp = await getApi(urlApi.agentDetails + agentId);
        if (resp.responseCode === 200) {
            setProfileData(resp.data);
        } else {
            toast.error(resp.message);
        }
    }

    async function getPaymentAccountList() {
        let resp = await getApi(urlApi.agentPaymentAccountsList + agentId);
        if (resp.responseCode === 200) {
            setBankDetails(resp.data);
            setSelectedBank(resp?.data?.length > 0 ? resp?.data[0] : null)
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getPaymentAccountList();
        getAgentDetails();
        return () => {
            setProfileData(null)
        }
    }, [agentId]);

    return (
        <Layout>
            <div className="flex gap-3 mb-3 flex-wrap">
                <IconButton icon={<IconCirclePlus size={20} />} text={"Add Payout"} />
                <IconButton icon={<IconReceipt size={20} />} text={"All Payouts"} />
                <IconButton icon={<IconReceiptRupee size={20} />} text={"All Invoices"} />
                <IconButton icon={<IconLinkPlus size={20} />} text={"Add Link"} />
                <AddGstModal buttonComponent={<IconButton icon={<IconTax size={20} />} text={"GST"} />} agentId={agentId} callback={() => getAgentDetails()} />
                <AddPanModal buttonComponent={<IconButton icon={<IconIdBadge2 size={20} />} text={"PAN"} />} agentId={agentId} callback={() => getAgentDetails()} />
                <AddPaymentMethod buttonComponent={<IconButton icon={<IconBuildingBank size={20} />} text={"Add Bank"} />} agentId={agentId} callback={() => getPaymentAccountList()} />
                <IconButton icon={<IconUserScan size={20} />} text={"Add Influencer"} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
                <StatsCard title={"Total Pay"} value={"₹5787"} />
                <StatsCard title={"Total Pay This FY"} value={100} />
                <StatsCard title={"Total TDS"} value={100} />
                <StatsCard title={"Total TDS This FY"} value={100} />
            </div>

            <div className='mb-3'>
                <div className="flex justify-between items-center p-1 mb-2">
                    <p className='mb-0 text-sm font-medium'>Link Listing</p>
                    <DateRange />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <StatsCard title={"Clicks"} value={"5787"} />
                    <StatsCard title={"Total Pay This FY"} value={100} />
                    <StatsCard title={"Total TDS"} value={100} />
                    <StatsCard title={"Total TDS This FY"} value={100} />
                    <StatsCard title={"Total Pay"} value={"₹5787"} />
                    <StatsCard title={"Total Pay This FY"} value={100} />
                    <StatsCard title={"Total TDS"} value={100} />
                    <StatsCard title={"Total TDS This FY"} value={100} />
                </div>
            </div>

            <div className='p-3 rounded-2xl mb-3'>
                <div className="flex justify-between items-center p-1">
                    <p className='mb-0 text-sm font-medium'>Agent Profile</p>
                    <UpdateAgent callback={() => getAgentDetails()} agentData={profileData} />
                </div>
                {/* <div className="both-side-faded-line"></div> */}
                <hr className='!my-3' />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                    <div className="p-3 rounded-2xl flex gap-3 items-center grid-cols-1 border border-primary">
                        <div className={`relative w-fit`}>
                            <img src={profileData?.profilePic ?? "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg"} id='profile-pic' alt="" className='w-full  min-w-[60px]  max-w-[120px] rounded-full aspect-square object-cover border-3 border-primary' />
                        </div>
                        <div className='grow overflow-hidden'>
                            <p className="mb-1 text-lg font-medium">{profileData?.name}</p>
                            <p className="mb-1 text-[var(--secondary-text)] break-words">{profileData?.email}</p>
                            <p className="mb-0">{profileData?.phone}</p>
                            <Badge bg={profileData?.status == 1 ? "success" : "warning"} >{profileData?.status == 1 ? "Active" : "InActive"}</Badge>
                        </div>
                    </div>

                    <div className="col-span-2">
                        <p className='mb-2 text-sm font-medium'>Personal Details</p>
                        <div className="grid grid-cols-2 gap-3">
                            <div className="col-span-1">
                                <input type="text" readOnly disabled className="w-full px-3 py-2 rounded-md border-2 text-sm" defaultValue={profileData?.name} id='username' placeholder='Name' />
                            </div>
                            <div className="col-span-1">
                                <input readOnly type="text" disabled className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder="Email" defaultValue={profileData?.email} />
                            </div>
                            <div className="col-span-1">
                                <input value={profileData?.phone} disabled readOnly type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder="Mobile" />
                            </div>
                            <div className="col-span-1">
                                <input readOnly type="text" disabled className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder="Address" defaultValue={profileData?.address} />
                            </div>
                            <div className="col-span-2">
                                <textarea defaultValue={profileData?.note} disabled readOnly name="" className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Note' id="note"></textarea>
                            </div>
                        </div>
                        <p className='text-sm'>Created On : {dateTimeConverter(profileData?.createdAt)}</p>
                    </div>

                </div>

                <div className="w-full mb-3">
                    <div className="flex justify-between items-center w-full flex-wrap">
                        <p className='mb-0 text-sm font-medium flex items-center !gap-1'>{selectedBank?.accountType == 1 ? "Bank" : "UPI"} Details {selectedBank?.isKycVerified ? <IconRosetteDiscountCheck className='text-green-700' title='KYC Verified' /> : <IconRosetteDiscountCheckOff className='text-red-700' title='KYC Not Verified' />}</p>
                        <div className='ms-auto flex flex-wrap items-center gap-3'>
                            {
                                bankDetails?.map((item, index) => {
                                    return (
                                        <button onClick={() => setSelectedBank(item)} key={item?._id} className={`px-4 py-1 text-sm ${selectedBank?._id == item?._id ? 'text-white bg-[var(--primary)] border-1 border-[var(--primary)]' : 'bg-transparent border-1 border-[var(--secondary-text)]'} border-b-transparent rounded-xl rounded-b-none`}>Bank {index + 1}</button>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="p-3 rounded-xl rounded-t-none border-1 border-[var(--secondary-text)]">
                        {selectedBank?.accountType == 1 && <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <div className="col-span-1">
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Account Holder Name</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" disabled placeholder="Bank Name" readOnly value={selectedBank?.bankDetails?.accountHolderName} />
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Account Number</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" disabled placeholder="Bank Name" readOnly value={selectedBank?.bankDetails?.accountNumber} />
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Bank Name</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" disabled placeholder="Bank Name" readOnly value={selectedBank?.bankDetails?.bankName} />
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="" className='text-sm font-semibold mb-1'>IFSC Code</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" disabled placeholder="Bank Name" readOnly value={selectedBank?.bankDetails?.ifscCode} />
                            </div>
                        </div>}
                        {selectedBank?.accountType == 2 && <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <div className="col-span-2">
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Account Holder Name</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" disabled readOnly value={selectedBank?.upiDetails?.accountHolderName} />
                            </div>
                            <div className="col-span-2">
                                <label htmlFor="" className='text-sm font-semibold mb-1'>UPI ID</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" disabled readOnly value={selectedBank?.upiDetails?.upiId} />
                            </div>
                        </div>}
                    </div>
                </div>

                <div className="channel-details">
                    <p className='mb-2 text-sm font-medium'>Channel Details</p>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                        <div className="col-span-1">
                            <div className="flex items-center border-1 border-gray-300 p-2 rounded-xl">
                                <input type="text" className="!outline-none w-full" placeholder="Channel Link" defaultValue={"www.Youtube/GauravTanejaFitnessClubs"} />
                                <IconLink color='var(--primary)' size={20} />
                            </div>
                        </div>
                        <div className="col-span-3">
                            <div className="flex gap-2 items-center border-1 border-gray-300 p-2 rounded-xl">
                                {
                                    ["facebook", "youtube", "instagram"].map((item) => {
                                        return (
                                            <div className="flex items-center gap-1 bg-[var(--secondary)] px-2 py-0.5 rounded-xl text-white">
                                                <IconX size={16} className='bg-[var(--secondary-text)] rounded-full p-0.5' />
                                                <p className="mb-0 text-sm">{item}</p>
                                            </div>
                                        )
                                    })
                                }
                                <input type="text" className="!outline-none w-full" placeholder="Channel Tags" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="col-span-1">
                    <div>
                        <div className="flex justify-between items-center p-1">
                            <p className='mb-0 text-sm font-medium'>Influencer List</p>
                            <IconDots color='var(--primary)' />
                        </div>
                        <InfluencerListOfAgentTable agentId={agentId} />
                    </div>
                </div>
                <div className="col-span-1">
                    <InfluencerGraph />
                </div>
            </div>
        </Layout>
    )
}

export default AgentDetails